module.exports = __webpack_public_path__ + "img/tag.d1692717.svg";